import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, withKeys as _withKeys, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a3b6c05"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-end" }
const _hoisted_2 = {
  key: 0,
  class: "middle-container mb-16"
}
const _hoisted_3 = { class: "middle-content mb-16" }
const _hoisted_4 = { class: "row row-cols-3 mb-16" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "section-title fw-bold" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "section-title fw-bold" }
const _hoisted_10 = { class: "content" }
const _hoisted_11 = { class: "row mb-16" }
const _hoisted_12 = { class: "col" }
const _hoisted_13 = { class: "section-title fw-bold" }
const _hoisted_14 = { class: "content" }
const _hoisted_15 = { class: "row row-cols-2 mb-24" }
const _hoisted_16 = { class: "col" }
const _hoisted_17 = { class: "section-title fw-bold" }
const _hoisted_18 = { class: "content" }
const _hoisted_19 = { class: "col" }
const _hoisted_20 = { class: "section-title fw-bold" }
const _hoisted_21 = { class: "content" }
const _hoisted_22 = {
  key: 0,
  class: "row mb-24"
}
const _hoisted_23 = { class: "col" }
const _hoisted_24 = { class: "section-title fw-bold" }
const _hoisted_25 = { class: "content" }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "section-title fw-bold mb-8" }
const _hoisted_29 = {
  key: 0,
  class: "d-flex w-100 mb-16 send-comment-section"
}
const _hoisted_30 = {
  key: 1,
  class: "comments-container"
}
const _hoisted_31 = { class: "content" }
const _hoisted_32 = { class: "fw-bold" }
const _hoisted_33 = {
  key: 0,
  class: "text-disabled fw-normal text-xs me-4"
}
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = {
  key: 1,
  class: "text-disabled fw-normal text-xs ms-4"
}
const _hoisted_36 = {
  key: 0,
  class: "btn-container ms-16"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-trash" }, null, -1))
const _hoisted_38 = {
  key: 2,
  class: "comments-container bg-white p-16"
}
const _hoisted_39 = { class: "bottom-section d-flex align-items-center justify-content-end" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-edit-light me-12",
  "aria-hidden": "true"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_button = _resolveComponent("v-button")!
  const _component_v_form_group_input_text = _resolveComponent("v-form-group-input-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.currentInterConsultation.status !== 'closed')
        ? (_openBlock(), _createBlock(_component_v_button, {
            key: 0,
            variant: "secondary",
            "aria-label": _ctx.$t('Finalizar interconsulta'),
            onClick: _ctx.finalizeInterConsultation
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('Finalizar interconsulta')), 1)
            ]),
            _: 1
          }, 8, ["aria-label", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    (!!_ctx.currentInterConsultation)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('Fecha')), 1),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$str.formatDateTime(_ctx.currentInterConsultation.createdAt)), 1)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t('Título')), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.currentInterConsultation.title), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('Descripción')), 1),
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.currentInterConsultation.description), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('Con')), 1),
                _createElementVNode("div", _hoisted_18, _toDisplayString(`${_ctx.currentInterConsultation.targetProfessional.name}
              ${_ctx.currentInterConsultation.targetProfessional.surname}`), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('De')), 1),
                _createElementVNode("div", _hoisted_21, _toDisplayString(`${_ctx.currentInterConsultation.creatorProfessional.name}
            ${_ctx.currentInterConsultation.creatorProfessional.surname}`), 1)
              ])
            ]),
            (_ctx.currentInterConsultation.expedient?.patient)
              ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.$t('Paciente')), 1),
                    _createElementVNode("div", _hoisted_25, [
                      (!!_ctx.currentInterConsultation.expedient)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(`${_ctx.currentInterConsultation.expedient.patient.user.name}
              ${_ctx.currentInterConsultation.expedient.patient.user.surname}`), 1))
                        : (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.$t(' - Sin paciente - ')), 1))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.$t('Comentarios')), 1),
          (_ctx.currentInterConsultation.status !== 'closed')
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                _createVNode(_component_v_form_group_input_text, {
                  class: "w-100 mb-0 me-8",
                  placeholder: _ctx.$t('Escribe tu mensaje'),
                  "yup-errors-variable": _ctx.errors.comment,
                  value: _ctx.comment,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (_ctx.comment = $event)),
                  onKeyup: _withKeys(_ctx.storeComment, ["enter"])
                }, null, 8, ["placeholder", "yup-errors-variable", "value", "onKeyup"]),
                _createVNode(_component_v_button, {
                  variant: "secondary",
                  "aria-label": _ctx.$t('Enviar'),
                  disabled: !_ctx.meta.valid || _ctx.accepted,
                  "is-loading": _ctx.accepted,
                  onClick: _ctx.storeComment
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('Enviar')), 1)
                  ]),
                  _: 1
                }, 8, ["aria-label", "disabled", "is-loading", "onClick"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.currentInterConsultation.comments && _ctx.currentInterConsultation.comments.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.currentInterConsultation.comments, (comment) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: comment.id,
                    class: _normalizeClass(["d-flex", {'justify-content-end text-end': comment.isOwner === 1}])
                  }, [
                    _createElementVNode("div", _hoisted_31, [
                      _createElementVNode("div", _hoisted_32, [
                        (comment.isOwner === 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, _toDisplayString(_ctx.$str.formatDateTime(comment.createdAt)), 1))
                          : _createCommentVNode("", true),
                        _createElementVNode("span", {
                          innerHTML: _ctx.displayProfessionalUsername(comment)
                        }, null, 8, _hoisted_34),
                        (comment.isOwner !== 1)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_35, _toDisplayString(_ctx.$str.formatDateTime(comment.createdAt)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("p", null, _toDisplayString(comment.content), 1)
                    ]),
                    (comment.author.id === _ctx.authUser.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                          _createVNode(_component_v_button, {
                            variant: "icon",
                            class: "text-primary p-0",
                            onClick: ($event: any) => (_ctx.confirmDeleteComment(comment.id)),
                            disabled: _ctx.removeCommentLoading === comment.id
                          }, {
                            default: _withCtx(() => [
                              _hoisted_37
                            ]),
                            _: 2
                          }, 1032, ["onClick", "disabled"])
                        ]))
                      : _createCommentVNode("", true)
                  ], 2))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_38, _toDisplayString(_ctx.$t('No hay comentarios')), 1))
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_39, [
      (_ctx.can('professional.inter-consultation.update') &&
      _ctx.currentInterConsultation.creatorProfessional?.user?.id === _ctx.authUser.id &&
      _ctx.currentInterConsultation.status !== 'closed')
        ? (_openBlock(), _createBlock(_component_v_button, {
            key: 0,
            variant: "outline-secondary",
            class: "new-consultation me-24",
            "aria-label": _ctx.$t('Editar'),
            onClick: _ctx.emitUpdateInterConsultationEvent
          }, {
            default: _withCtx(() => [
              _hoisted_40,
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('Editar')), 1)
            ]),
            _: 1
          }, 8, ["aria-label", "onClick"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}